// extracted by mini-css-extract-plugin
export default {"container":"VerseRanges_container__INhzq"};